export const colorStylesData = {
  "bg-slate-100": "background-color: #f1f5f9;\r\n    color: #0f172a;",
  "bg-slate-300": "background-color: #cbd5e1;\r\n    color: #0f172a;",
  "bg-slate-500": "background-color: #64748b;\r\n    color: #fff;",
  "bg-slate-700": "background-color: #334155;\r\n    color: #fff;",
  "bg-slate-900": "background-color: #0f172a;\r\n    color: #fff;",
  "bg-gray-100": "background-color: #f3f4f6;\r\n    color: #111827;",
  "bg-gray-300": "background-color: #d1d5db;\r\n    color: #111827;",
  "bg-gray-500": "background-color: #6b7280;\r\n    color: #fff;",
  "bg-gray-700": "background-color: #374151;\r\n    color: #fff;",
  "bg-gray-900": "background-color: #111827;\r\n    color: #fff;",
  "bg-zinc-100": "background-color: #f4f4f5;\r\n    color: #18181b;",
  "bg-zinc-300": "background-color: #d4d4d8;\r\n    color: #18181b;",
  "bg-zinc-500": "background-color: #71717a;\r\n    color: #fff;",
  "bg-zinc-700": "background-color: #3f3f46;\r\n    color: #fff;",
  "bg-zinc-900": "background-color: #18181b;\r\n    color: #fff;",
  "bg-red-100": "background-color: #fee2e2;\r\n    color: #7f1d1d;",
  "bg-red-300": "background-color: #fca5a5;\r\n    color: #7f1d1d;",
  "bg-red-500": "background-color: #ef4444;\r\n    color: #fff;",
  "bg-red-700": "background-color: #b91c1c;\r\n    color: #fff;",
  "bg-red-900": "background-color: #7f1d1d;\r\n    color: #fff;",
  "bg-orange-100": "background-color: #ffedd5;\r\n    color: #7c2d12;",
  "bg-orange-300": "background-color: #fdba74;\r\n    color: #7c2d12;",
  "bg-orange-500": "background-color: #f97316;\r\n    color: #fff;",
  "bg-orange-700": "background-color: #c2410c;\r\n    color: #fff;",
  "bg-orange-900": "background-color: #7c2d12;\r\n    color: #fff;",
  "bg-amber-100": "background-color: #fef3c7;\r\n    color: #78350f;",
  "bg-amber-300": "background-color: #fcd34d;\r\n    color: #78350f;",
  "bg-amber-500": "background-color: #f59e0b;\r\n    color: #fff;",
  "bg-amber-700": "background-color: #b45309;\r\n    color: #fff;",
  "bg-amber-900": "background-color: #78350f;\r\n    color: #fff;",
  "bg-yellow-100": "background-color: #fef9c3;\r\n    color: #713f12;",
  "bg-yellow-300": "background-color: #fde047;\r\n    color: #713f12;",
  "bg-yellow-500": "background-color: #eab308;\r\n    color: #fff;",
  "bg-yellow-700": "background-color: #a16207;\r\n    color: #fff;",
  "bg-yellow-900": "background-color: #713f12;\r\n    color: #fff;",
  "bg-lime-100": "background-color: #ecfccb;\r\n    color: #365314;",
  "bg-lime-300": "background-color: #bef264;\r\n    color: #365314;",
  "bg-lime-500": "background-color: #84cc16;\r\n    color: #fff;",
  "bg-lime-700": "background-color: #4d7c0f;\r\n    color: #fff;",
  "bg-lime-900": "background-color: #365314;\r\n    color: #fff;",
  "bg-green-100": "background-color: #dcfce7;\r\n    color: #14532d;",
  "bg-green-300": "background-color: #86efac;\r\n    color: #14532d;",
  "bg-green-500": "background-color: #22c55e;\r\n    color: #fff;",
  "bg-green-700": "background-color: #15803d;\r\n    color: #fff;",
  "bg-green-900": "background-color: #14532d;\r\n    color: #fff;",
  "bg-emerald-100": "background-color: #d1fae5;\r\n    color: #064e3b;",
  "bg-emerald-300": "background-color: #6ee7b7;\r\n    color: #064e3b;",
  "bg-emerald-500": "background-color: #10b981;\r\n    color: #fff;",
  "bg-emerald-700": "background-color: #047857;\r\n    color: #fff;",
  "bg-emerald-900": "background-color: #064e3b;\r\n    color: #fff;",
  "bg-teal-100": "background-color: #ccfbf1;\r\n    color: #134e4a;",
  "bg-teal-300": "background-color: #5eead4;\r\n    color: #134e4a;",
  "bg-teal-500": "background-color: #14b8a6;\r\n    color: #fff;",
  "bg-teal-700": "background-color: #0f766e;\r\n    color: #fff;",
  "bg-teal-900": "background-color: #134e4a;\r\n    color: #fff;",
  "bg-cyan-100": "background-color: #cffafe;\r\n    color: #164e63;",
  "bg-cyan-300": "background-color: #67e8f9;\r\n    color: #164e63;",
  "bg-cyan-500": "background-color: #06b6d4;\r\n    color: #fff;",
  "bg-cyan-700": "background-color: #0e7490;\r\n    color: #fff;",
  "bg-cyan-900": "background-color: #164e63;\r\n    color: #fff;",
  "bg-sky-100": "background-color: #e0f2fe;\r\n    color: #0c4a6e;",
  "bg-sky-300": "background-color: #7dd3fc;\r\n    color: #0c4a6e;",
  "bg-sky-500": "background-color: #0ea5e9;\r\n    color: #fff;",
  "bg-sky-700": "background-color: #0369a1;\r\n    color: #fff;",
  "bg-sky-900": "background-color: #0c4a6e;\r\n    color: #fff;",
  "bg-blue-100": "background-color: #dbeafe;\r\n    color: #1e3a8a;",
  "bg-blue-300": "background-color: #93c5fd;\r\n    color: #1e3a8a;",
  "bg-blue-500": "background-color: #3b82f6;\r\n    color: #fff;",
  "bg-blue-700": "background-color: #1d4ed8;\r\n    color: #fff;",
  "bg-blue-900": "background-color: #1e3a8a;\r\n    color: #fff;",
  "bg-indigo-100": "background-color: #e0e7ff;\r\n    color: #312e81;",
  "bg-indigo-300": "background-color: #a5b4fc;\r\n    color: #312e81;",
  "bg-indigo-500": "background-color: #6366f1;\r\n    color: #fff;",
  "bg-indigo-700": "background-color: #4338ca;\r\n    color: #fff;",
  "bg-indigo-900": "background-color: #312e81;\r\n    color: #fff;",
  "bg-violet-100": "background-color: #ede9fe;\r\n    color: #4c1d95;",
  "bg-violet-300": "background-color: #c4b5fd;\r\n    color: #4c1d95;",
  "bg-violet-500": "background-color: #8b5cf6;\r\n    color: #fff;",
  "bg-violet-700": "background-color: #6d28d9;\r\n    color: #fff;",
  "bg-violet-900": "background-color: #4c1d95;\r\n    color: #fff;",
  "bg-purple-100": "background-color: #f3e8ff;\r\n    color: #581c87;",
  "bg-purple-300": "background-color: #d8b4fe;\r\n    color: #581c87;",
  "bg-purple-500": "background-color: #a855f7;\r\n    color: #fff;",
  "bg-purple-700": "background-color: #7e22ce;\r\n    color: #fff;",
  "bg-purple-900": "background-color: #581c87;\r\n    color: #fff;",
  "bg-fuchsia-100": "background-color: #fae8ff;\r\n    color: #701a75;",
  "bg-fuchsia-300": "background-color: #f0abfc;\r\n    color: #701a75;",
  "bg-fuchsia-500": "background-color: #d946ef;\r\n    color: #fff;",
  "bg-fuchsia-700": "background-color: #a21caf;\r\n    color: #fff;",
  "bg-fuchsia-900": "background-color: #701a75;\r\n    color: #fff;",
  "bg-pink-100": "background-color: #fce7f3;\r\n    color: #831843;",
  "bg-pink-300": "background-color: #f9a8d4;\r\n    color: #831843;",
  "bg-pink-500": "background-color: #ec4899;\r\n    color: #fff;",
  "bg-pink-700": "background-color: #be185d;\r\n    color: #fff;",
  "bg-pink-900": "background-color: #831843;\r\n    color: #fff;",
  "bg-rose-100": "background-color: #ffe4e6;\r\n    color: #881337;",
  "bg-rose-300": "background-color: #fda4af;\r\n    color: #881337;",
  "bg-rose-500": "background-color: #f43f5e;\r\n    color: #fff;",
  "bg-rose-700": "background-color: #be123c;\r\n    color: #fff;",
  "bg-rose-900": "background-color: #881337;\r\n    color: #fff;",
  "outline-slate": "border: 2px solid #64748b;\r\n    color: #94a3b8;\r\n    background: transparent;",
  "outline-gray": "border: 2px solid #6b7280;\r\n    color: #9ca3af;\r\n    background: transparent;",
  "outline-zinc": "border: 2px solid #71717a;\r\n    color: #a1a1aa;\r\n    background: transparent;",
  "outline-red": "border: 2px solid #ef4444;\r\n    color: #f87171;\r\n    background: transparent;",
  "outline-orange": "border: 2px solid #f97316;\r\n    color: #fb923c;\r\n    background: transparent;",
  "outline-amber": "border: 2px solid #f59e0b;\r\n    color: #fbbf24;\r\n    background: transparent;",
  "outline-yellow": "border: 2px solid #eab308;\r\n    color: #facc15;\r\n    background: transparent;",
  "outline-lime": "border: 2px solid #84cc16;\r\n    color: #a3e635;\r\n    background: transparent;",
  "outline-green": "border: 2px solid #22c55e;\r\n    color: #4ade80;\r\n    background: transparent;",
  "outline-emerald": "border: 2px solid #10b981;\r\n    color: #34d399;\r\n    background: transparent;",
  "outline-teal": "border: 2px solid #14b8a6;\r\n    color: #2dd4bf;\r\n    background: transparent;",
  "outline-cyan": "border: 2px solid #06b6d4;\r\n    color: #22d3ee;\r\n    background: transparent;",
  "outline-sky": "border: 2px solid #0ea5e9;\r\n    color: #38bdf8;\r\n    background: transparent;",
  "outline-blue": "border: 2px solid #3b82f6;\r\n    color: #60a5fa;\r\n    background: transparent;",
  "outline-indigo": "border: 2px solid #6366f1;\r\n    color: #818cf8;\r\n    background: transparent;",
  "outline-violet": "border: 2px solid #8b5cf6;\r\n    color: #a78bfa;\r\n    background: transparent;",
  "outline-purple": "border: 2px solid #a855f7;\r\n    color: #c084fc;\r\n    background: transparent;",
  "outline-fuchsia": "border: 2px solid #d946ef;\r\n    color: #e879f9;\r\n    background: transparent;",
  "outline-pink": "border: 2px solid #ec4899;\r\n    color: #f472b6;\r\n    background: transparent;",
  "outline-rose": "border: 2px solid #f43f5e;\r\n    color: #fb7185;\r\n    background: transparent;",
  "bg-facebook": "background: #1877f2;",
  "bg-twitter": "background: #1da1f2;",
  "bg-instagram": "background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);",
  "bg-linkedin": "background: #0077b5;",
  "bg-youtube": "background: #ff0000;",
  "bg-github": "background: #333;",
  "bg-discord": "background: #5865F2;",
  "bg-twitch": "background: #9146FF;",
  "bg-slack": "background: #4A154B;",
  "bg-spotify": "background: #1DB954;"
};
